import { render, staticRenderFns } from "./_base-confirm-modal.vue?vue&type=template&id=52ccb3ac&"
import script from "./_base-confirm-modal.vue?vue&type=script&lang=js&"
export * from "./_base-confirm-modal.vue?vue&type=script&lang=js&"
import style0 from "./_base-confirm-modal.vue?vue&type=style&index=0&id=52ccb3ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports